/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SelectProfileRequestDto } from '../../models/select-profile-request-dto';
import { SelectProfileResultDto } from '../../models/select-profile-result-dto';

export interface OrderProfileGetSelectedProfileDetails$Params {
  'x-wks-id'?: string;
  'x-app-name'?: string;
  'x-usr-id'?: string;
  'x-xcc-extid'?: string;
  'x-xcc-id'?: string;
  'x-app-version'?: string;
  'x-wks-name'?: string;
  'x-trace-id'?: string;
      body: SelectProfileRequestDto
}

export function orderProfileGetSelectedProfileDetails(http: HttpClient, rootUrl: string, params: OrderProfileGetSelectedProfileDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<SelectProfileResultDto>> {
  const rb = new RequestBuilder(rootUrl, orderProfileGetSelectedProfileDetails.PATH, 'post');
  if (params) {
    rb.header('x-wks-id', params['x-wks-id'], {});
    rb.header('x-app-name', params['x-app-name'], {});
    rb.header('x-usr-id', params['x-usr-id'], {});
    rb.header('x-xcc-extid', params['x-xcc-extid'], {});
    rb.header('x-xcc-id', params['x-xcc-id'], {});
    rb.header('x-app-version', params['x-app-version'], {});
    rb.header('x-wks-name', params['x-wks-name'], {});
    rb.header('x-trace-id', params['x-trace-id'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SelectProfileResultDto>;
    })
  );
}

orderProfileGetSelectedProfileDetails.PATH = '/api/order-profile/selected-profile-details';
